const GlobalTagItemType = {
  Red: 'red',
  Blue: 'blue',
  Green: 'green',
  Yellow: 'yellow'
};
export default GlobalTagItemType;
